import styled, { withTheme } from 'styled-components';
import ListItemIcon from './ListItemIcon';
import DownloadIcon from '../../assets/images/download-icon.svg';

const SeperatedDownloadDataIcon = styled(ListItemIcon)`
  border-left: 1px solid ${(props) => props.theme.palette.common.backgroundDark};
  background: url(\"${DownloadIcon}\") no-repeat right center;
`;

export default withTheme(SeperatedDownloadDataIcon);
